export const parseUrlParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  
  return {
    retailAssoc: urlParams.get('Retail_Assoc_Key') || '',
    coa: urlParams.get('COA_Key') || '',
    period: urlParams.get('Period_Key') || '',
    username: urlParams.get('username') || '',
    lineitem: urlParams.get('lineitem') || '',
    comment: urlParams.get('comment') || '',
  };
};

export const validateParams = (params) => {
  return !!(params.retailAssoc && params.coa && params.period);
};